import React, { FC, ReactNode, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTransmissions, configureMap, configurePlatform, configureStaticFiles } from 'store/global'
import Loader from 'components/Loader/Loader'
import { fetchCurrentUser, selectCurrentUser, selectAuthError } from 'store/global'
import ForbiddenAccessPage from 'uikit/pages/ForbiddenAccessPage/ForbiddenAccessPage'
import { handleLogout } from 'components/Header/utils'

interface IAuthWrapper {
  children: ReactNode
}

const AuthWrapper: FC<IAuthWrapper> = ({ children }) => {
  const dispatch = useDispatch()
  const currentUser = useSelector(selectCurrentUser)
  const authError = useSelector(selectAuthError)

  useEffect(() => {
    if (Object.keys(currentUser || {}).length !== 0) {
      dispatch(fetchTransmissions())
      dispatch(configureMap())
      dispatch(configurePlatform())
      dispatch(configureStaticFiles())
    }
  }, [currentUser, dispatch])

  useEffect(() => {
    dispatch(fetchCurrentUser())
  }, [dispatch])

  if (authError?.type === 'forbidden') {
    return (
      <ForbiddenAccessPage
        message={authError.message || 'You do not have permission to access this application.'}
        onSubmit={handleLogout}
      />
    )
  }

  if (Object.keys(currentUser).length === 0) {
    return <Loader type='globalLoading' message={''} />
  }

  return <>{children}</>
}

export default AuthWrapper
